import { symbols } from "@frameworks/web/constant/symbols";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
class HeaderPresenter {
    constructor(useCases, useCasesStream, actions) {
        this.useCases = useCases;
        this.useCasesStream = useCasesStream;
        this.actions = actions;
    }
    async getMenuData() {
        const headerData = await this.useCases.getMenuData.getMenuData();
        return this.actions.getMenuData(headerData);
    }
    RemoveHeaderData(showHeader) {
        this.actions.RemoveHeaderData(showHeader);
    }
    setScrollHeader(scrollHeader) {
        this.actions.setScrollHeader(scrollHeader);
    }
    getStreamData(subscribe) {
        const symb = [symbols[0].symbol, symbols[1].symbol];
        const streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
        ];
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, async (mappedData) => {
            if (symb.includes(mappedData.symbol)) {
                this.actions.getStreamData([mappedData]);
            }
        }, symb, streamMapKey);
    }
    async getMarketData(code) {
        this.useCases.getMarketData.execute({
            onSuccess: (data) => {
                if (data.data.bull.length > 0) {
                    data.data.bull.map((c) => {
                        code.map((x) => {
                            if (x === c.sym) {
                                this.actions.getMarketData([
                                    {
                                        symbol: c.sym,
                                        curPrice: c.ltp,
                                        changePrice: c.chg,
                                        changePercentage: c.chgP,
                                    },
                                ]);
                            }
                        });
                    });
                }
            },
            onError: () => { },
        }, null);
    }
    HideFixedNavMob(showFixedNavMob) {
        this.actions.HideFixedNavMob(showFixedNavMob);
    }
    HeaderBG_Properties(properties) {
        this.actions.headerBG_Properties(properties);
    }
}
export default HeaderPresenter;
